import React, { useState } from "react";
import axios from "../../api/axios";
import "./SetContractPriceModal.css";

export default function SetContractPriceModal({
  isOpen,
  onClose,
  contract,
  token,
  locale = "kz",
  onSaved = () => {},
}) {
  // Хуки ВСЕГДА вызываем
  const t = {
    kz: {
      title: "Келісімшарт сомасын енгізу",
      amount: "Сома (санмен)",
      amountTextKz: "Сома (қазақша жазумен)",
      amountTextRu: "Сома (орысша жазумен)",
      save: "Сақтау",
      cancel: "Болдырмау",
      success: "Сома сақталды!",
      error: "Соманы сақтау кезінде қате.",
      required: "Барлық өрістерді толтырыңыз",
    },
    ru: {
      title: "Указать сумму договора",
      amount: "Сумма (числом)",
      amountTextKz: "Сумма (на казахском)",
      amountTextRu: "Сумма (на русском)",
      save: "Сохранить",
      cancel: "Отмена",
      success: "Сумма сохранена!",
      error: "Ошибка при сохранении суммы.",
      required: "Заполните все поля",
    },
  }[locale];

  const [form, setForm] = useState({
    amount_numeric: "",
    amount_text_kz: "",
    amount_text_ru: "",
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const disabled =
    !String(form.amount_numeric).trim() ||
    !form.amount_text_kz.trim() ||
    !form.amount_text_ru.trim();

  const submit = async () => {
    if (disabled) {
      setErr(t.required);
      return;
    }
    setErr("");
    setMsg("");
    try {
      setLoading(true);
      const url = `/contracts/${contract?.id}/set-price`;
      await axios.post(
        url,
        {
          amount_numeric: Number(form.amount_numeric),
          amount_text_kz: form.amount_text_kz,
          amount_text_ru: form.amount_text_ru,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMsg(t.success);
      // Обновим карточку и откроем окно подписи
      setTimeout(() => {
        onSaved();
        onClose();
      }, 500);
    } catch (e) {
      console.error(e);
      setErr(t.error);
    } finally {
      setLoading(false);
    }
  };

  // Условный рендер (после хуков)
  if (!isOpen) return null;

  return (
    <div className="spm-overlay" onMouseDown={onClose}>
      <div className="spm-box" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="spm-title">{t.title}</h3>

        <div className="spm-body">
          <label className="spm-field">
            <span>{t.amount}</span>
            <input
              type="number"
              value={form.amount_numeric}
              onChange={(e) =>
                setForm((s) => ({ ...s, amount_numeric: e.target.value }))
              }
              min="0"
              step="1"
            />
          </label>

          <label className="spm-field">
            <span>{t.amountTextKz}</span>
            <input
              type="text"
              value={form.amount_text_kz}
              onChange={(e) =>
                setForm((s) => ({ ...s, amount_text_kz: e.target.value }))
              }
            />
          </label>

          <label className="spm-field">
            <span>{t.amountTextRu}</span>
            <input
              type="text"
              value={form.amount_text_ru}
              onChange={(e) =>
                setForm((s) => ({ ...s, amount_text_ru: e.target.value }))
              }
            />
          </label>

          {err && <div className="spm-alert spm-err">{err}</div>}
          {msg && <div className="spm-alert spm-ok">{msg}</div>}
        </div>

        <div className="spm-actions">
          <button className="btn-primary" onClick={submit} disabled={loading || disabled}>
            {t.save}
          </button>
          <button className="btn-secondary" onClick={onClose} disabled={loading}>
            {t.cancel}
          </button>
        </div>
      </div>
    </div>
  );
}
